import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
    getParticipantResults
} from "../../../../../redux/trainingclass/trainingClassState";
import { BookOpen } from "lucide-react";
import TrainingModuleCard from "views/console/training-modules/components/TrainingModuleCard";
import { Pagination } from "antd";

const ResultModal = ({ 
    recordId,
    getList, 
    recordData,
    classeId,
    pagination
}) => {

    useEffect(() => {
        if (recordId && classeId) {
            getList({ participantId: recordId, classeId }); 
        }
    }, [recordId, classeId, getList]);


    return (
        <div className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
            <div className="flex flex-col gap-2 text-left">
                <h1 className="text-xl font-semibold leading-snug">Participant Modules Result</h1>
                <p className="text-base text-slate-700 leading-tight">Module performance details </p>
            </div>
            <div className="h-[390px] overflow-auto space-y-3 mt-2 pr-2">
                {recordData?.module_result?.length > 0 ? (
                    recordData?.module_result?.map((result) => (
                        <TrainingModuleCard
                            key={result.trs_id}
                            recordData={result}
                            showStat={false}
                            showResult={true}
                        />
                    ))
                ) : (
                    <div className="text-center py-12">
                        <BookOpen className="w-12 h-12 text-slate-700 mx-auto mb-4"/>
                        <p className="text-slate-700">
                            No modules found for this participant
                        </p>
                    </div>
                )}
            </div>
            <div className="flex justify-end py-1">
                <Pagination
                    current={pagination?.current_page || 1}
                    pageSize={pagination?.per_page || 10}
                    total={pagination?.total || 0}
                    showSizeChanger={false}
                    onChange={(page) =>
                        getList({
                            page,
                            paginate: pagination?.per_page || 10,
                        })
                    }
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordData: state.trainingClass.trainingClassParticipantResult?.data,
    pagination: state.trainingClass.trainingClassParticipantResult?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
    getList: (data) => dispatch(getParticipantResults(data)),
});

export default connect(mapStateToProps, mapDispatchToProps) (ResultModal);